import { Icon } from 'components/Icon';
import { SunMoon } from 'lucide-static';

let transitioning = false;

const themeButton = (
	<div class="absolute right-8 top-4 z-30">
		<button
			class="size-10 rounded-md bg-gray-200 p-2 text-gray-800 shadow-md transition-all hover:rotate-3 hover:scale-105 hover:shadow-accent-500/80 active:-rotate-3 active:scale-95 dark:bg-gray-700 dark:text-gray-100"
			on:click={() => {
				transitionBasic();
			}}
		>
			<Icon icon={SunMoon} class="size-full" />
		</button>
	</div>
);

if (localStorage.getItem('theme') === 'dark') {
	const app = document.querySelector('#app') as HTMLElement;
	app.classList.add('dark');
	themeButton.classList.add('dark');
}

document.body.append(themeButton);

// cool, but sometimes laggy because browsers refuse to pre-optimize the transition despise setting `will-change: clip-path`
// maybe some day it will work correctly...
function _transitionFancy() {
	if (transitioning) return;

	transitioning = true;
	const app = document.querySelector('#app') as HTMLElement;
	const appClone = app.cloneNode(true) as HTMLElement;
	appClone.style.position = 'absolute';
	appClone.style.inset = '0';
	appClone.style.pointerEvents = 'none';

	app.style.position = 'relative';
	app.style.zIndex = '1';
	app.style.clipPath = 'circle(0.4% at 95% 5%)';
	app.style.transition = 'clip-path .7s cubic-bezier(0.4, 0.03, 0.13, 0.98)';

	document.body.append(appClone);

	app.classList.toggle('dark');
	const isDark = app.classList.contains('dark');
	themeButton.classList.toggle('dark');
	// app.style.colorScheme = isDark ? 'dark' : 'light';
	localStorage.setItem('theme', isDark ? 'dark' : 'light');

	requestAnimationFrame(() => {
		app.style.clipPath = 'circle(150% at 95% 5%)';
	});

	setTimeout(() => {
		appClone.remove();
		app.style.position = '';
		app.style.zIndex = '';
		app.style.clipPath = '';
		app.style.transition = '';

		transitioning = false;
	}, 800);
}

function transitionBasic() {
	const app = document.querySelector('#app') as HTMLElement;

	app.classList.toggle('dark');
	const isDark = app.classList.contains('dark');
	themeButton.classList.toggle('dark');
	localStorage.setItem('theme', isDark ? 'dark' : 'light');
}
